import { html } from 'lit';
import { CrntElement } from '../../lib/crnt-element.js';
import { trustedCSS } from '../../lib/css/css.js';
import formControlLabelStyles from './form-control-label.css.js';

class CrntFormControlLabel extends CrntElement {
  static {
    this.styles = trustedCSS(formControlLabelStyles);
  }
  static {
    this.tagName = "crnt-form-control-label";
  }
  render() {
    return html`<slot class="crnt-form-control-label" part="label"></slot>`;
  }
}

export { CrntFormControlLabel };
